import { normalizeApiError } from "../../../utils/normalizeApiError";
import axiosInstance from "../../axiosInstance";

export const getProjectOwners = async (
  orgUuid: string
) => {
  try {
    const { data } = await axiosInstance.get(
      `organisation/${orgUuid}/get-all-pmo-admin-and-pmo-manager`
    );


    return data.response;
  } catch (error) {
    throw normalizeApiError(error);
  }
};

